// integer-length.directive.ts
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNupIntegerLength]',
})
export class IntegerLengthGeoNUPDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const inputValue: string = input.value;

    // Retire tout ce qui n'est pas un chiffre (y compris les espaces)
    const numericValue: string = inputValue.replace(/[^\d]/g, '');

    // Limite la saisie à 9 chiffres
    const maxLength = 9;
    const truncatedValue = numericValue.slice(0, maxLength);

    // Met à jour la valeur du champ seulement si elle a changé
    if (input.value !== truncatedValue) {
      input.value = truncatedValue;

      // Déclenche les événements pour la détection de changement d'Angular
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  @HostListener('keydown', ['$event']) onKeydown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value.replace(/[^\d]/g, '');

    // Liste des touches autorisées
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
    ];

    // Autorise les touches de contrôle
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Autorise Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
      return;
    }

    // Empêche la saisie d'espaces
    if (event.key === ' ') {
      event.preventDefault();
      return;
    }

    // Empêche la saisie si la longueur maximale est atteinte
    if (currentValue.length >= 9) {
      event.preventDefault();
      return;
    }

    // Empêche la saisie de caractères non numériques
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';

    // Retire tout ce qui n'est pas un chiffre (y compris les espaces)
    const numericValue = pastedText.replace(/[^\d]/g, '');
    const truncatedValue = numericValue.slice(0, 9);

    const input = event.target as HTMLInputElement;
    input.value = truncatedValue;

    // Déclenche les événements pour la détection de changement d'Angular
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
